<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @search-reset="searchClear" @row-save="handleSave"
        @row-update="handleUpdate" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="mini" plain @click.stop="handleAdd()">预约工单</el-button>
          <el-button type="success" icon="el-icon-download" size="mini" plain
            @click.stop="downloadExcelWorkOrder">下载Excel</el-button>
          <!-- <el-button
            type="warning"
            icon="el-icon-close"
            size="mini"
            plain
            v-if="permission.JOINS_WORK_SERVICE_ORDER"
            @click.stop="handleDel('DELETE_OPTION', '逻辑删除')"
            >删除</el-button
          > -->
          <!-- v-if="permission.JOINS_WORK_ITEM_DEL_TRUE" -->
          <!-- <el-button
            type="danger"
            icon="el-icon-error"
            size="mini"
            plain
            v-if="permission.JOINS_WORK_SERVICE_ORDER"
            @click.stop="handleDel('DELETE_OPTION', '物理删除')"
            >物理删除</el-button
          > -->
        </template>
        <template slot-scope="scope" slot="menuBtn">
          <div style="display: flex;height: 100%;width: 100%;">
            <el-button type="primary" icon="el-icon-edit" size="mini" plain
            @click.stop="handleEdit(scope.row, scope.index)">
            编辑
          </el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" plain v-if="
            [
              'IN_SERVICE',
              'FOR_SERVICE',
              'WAIT_ACCEPT',
              'WAIT_DISTRIBUTE',
              'ENGINEER_ON_THE_WAY',
            ].includes(scope.row.status)
          " @click.stop="cancelWorkOrder(scope.row.id)">
            取消
          </el-button>

          <el-button type="primary" size="mini" plain v-if="
            scope.row.status === 'TO_BE_THE_FINAL' &&
            scope.row.isAuditor === 'YES'
          " @click.stop="passAudit(scope.row, scope.index)">
            <i class="el-icon-check"></i> 通过
          </el-button>

          <el-button type="danger" size="mini" plain v-if="
            scope.row.status === 'TO_BE_THE_FINAL' &&
            scope.row.isAuditor === 'YES'
          " @click.stop="rejectAudit(scope.row, scope.index)">
            <i class="el-icon-close"></i> 拒绝
          </el-button>

          <el-button type="success" size="mini" plain
            v-if="scope.row.status === 'WAIT_PAY' && scope.row.isPay === 'YES'" @click.stop="openPay(scope.row)">
            付款
          </el-button>

          <el-button type="info" icon="el-icon-message" size="mini" plain v-if="scope.row.status === 'TO_EVALUATE'"
            @click.stop="showEvaluate(scope.row)">
            评价
          </el-button>

          <el-button type="success" icon="el-icon-view" size="mini" plain @click.stop="serviceListing(scope.row)">
            查看
          </el-button>
          </div>
        </template>

        <template slot="search">
          <el-form-item label="服务类目名称" size="mini" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="superiorId" placeholder="请选择服务类目名称" width="200" value-key="id" clearable
                @change="selectSuperiorId">
                <el-option v-for="item in serviceCategorys" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="服务项目名称" size="mini" style="margin-top: 4px">
            <el-col :md="32">
              <el-select v-model="serviceCategoryName" placeholder="请选择服务项目名称" width="300" clearable value-key="id">
                <el-option v-for="item in categoryTypes" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>
        <!-- 请输入预约卡号 ，请求预约卡号接口验证是否已存在，已存在则提示-->
        <template slot-scope="scope" slot="reservationNumForm">
          <el-input type="input" name="title" maxlength="12" v-model="scope.row.reservationNum" placeholder="输入预约卡号(选填)"
            @blur="checkreservationNum(scope.row)"></el-input>
        </template>
        <!-- 业主姓名 -->
        <template slot-scope="scope" slot="ownerNameForm">
          <!-- 如果联系人类型为OWNER则自动填充并且不可编辑-->
          <el-input v-if="scope.row.appointmentType == 'OWNER'" disabled type="input" name="title"
            v-model="scope.row.reservationName" placeholder="请输入业主姓名"></el-input>
          <el-input v-if="scope.row.appointmentType != 'OWNER'" type="input" name="title" v-model="scope.row.ownerName"
            placeholder="请输入业主姓名"></el-input>
        </template>
        <!-- 业主电话 -->
        <template slot-scope="scope" slot="ownerMobileForm">
          <!-- 如果联系人类型为OWNER则自动填充并且不可编辑-->
          <el-input v-if="scope.row.appointmentType == 'OWNER'" disabled type="input" name="title"
            v-model="scope.row.reservationMobile" placeholder="请输入业主电话"></el-input>
          <el-input v-if="scope.row.appointmentType != 'OWNER'" type="input" name="title"
            v-model="scope.row.ownerMobile" placeholder="请输入业主电话"></el-input>
        </template>
        <template slot-scope="scope" slot="workUserIdForm">
          <!-- 可取消 -->
          <el-select v-model="workerUser" placeholder="工程师姓名/电话" filterable remote :remote-method="remoteMethod"
            value-key="id" clearable>
            <el-option v-for="user in users" :key="user.id" :label="user.realName" :value="user"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="provinceForm">
          <el-input type="input" name="title" disabled :value="point.pname"></el-input>
        </template>
        <template slot-scope="scope" slot="cityForm">
          <el-input type="input" name="title" disabled :value="point.cityname"></el-input>
        </template>
        <template slot-scope="scope" slot="areaForm">
          <el-input type="input" name="title" disabled :value="point.adname"></el-input>
        </template>
        <!-- 详细地址 -->
        <template slot-scope="scope" slot="addressForm">
          <el-input type="input" name="title" v-model="point.address"></el-input>
        </template>
        <template slot-scope="scope" slot="provincesForm">
          <avue-map v-model="point"></avue-map>
        </template>
        <template slot-scope="scope" slot="serviceCategoryForm">
          <el-select v-model="serviceCategory" placeholder="请选择服务类目" required @change="choseWorkServiceItem"
            value-key="id">
            <el-option v-for="serviceCategory in serviceCategorys" :key="serviceCategory.id"
              :label="serviceCategory.name" :value="serviceCategory"></el-option>
          </el-select>
        </template>
        <template slot-scope="scope" slot="serviceCategory">{{
          scope.row.serviceCategoryName
        }}</template>
        <template slot-scope="scope" slot="serviceItems">{{
          scope.row.serviceItemName
        }}</template>
        <template slot-scope="scope" slot="workUserId">{{
          scope.row.realName
        }}</template>
        <template slot-scope="scope" slot="address">{{ scope.row.province }}{{ scope.row.city }}{{ scope.row.area
          }}{{ scope.row.address }}</template>
        <!-- 详细地址 -->
        <!-- <template slot-scope="scope" slot="address1">{{
          scope.row.address
        }}</template> -->
        <template slot-scope="scope" slot="status">
          <el-tag size="mini" v-for="statusObj of workOrderStatus" :key="statusObj.value"
            v-if="statusObj.value === scope.row.status" :type="getStatusTagType(statusObj.value)">{{ statusObj.label
            }}</el-tag>
        </template>

        <template slot-scope="scope" slot="serviceItemsForm">
          <el-select v-model="serviceItem" placeholder="请选择服务项目" required @change="choseServiceItem" value-key="id">
            <el-option v-for="joinsWorkServiceItem in joinsWorkServiceItems" :key="joinsWorkServiceItem.id"
              :label="joinsWorkServiceItem.name" :value="joinsWorkServiceItem.id"></el-option>
          </el-select>
        </template>
      </avue-crud>
      <template>
        <el-dialog :visible.sync="rechargeDialog" title="充值" center width="1000px">
          <div class="remittance"
            style="font-size: 10px;display: flex;flex-flow: column nowrap; align-items: flex-start;margin-left:205px">
            <div class="recharge">
              <span style="width:130px;text-align:left;">请输入充值金额:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="number" placeholder="请输入充值金额" v-model="rechargeMoney" style="width:215px"></el-input>
            </div>
            <div style="display: flex;justify-content:flex-start;">
              <span style="width:130px;text-align:left;">支付方式:</span>
              <div>
                <el-radio v-model="payRadio" label="OFFLINE_REMIT" @change="rechargeWayOFFLINE_REMIT">线下汇款</el-radio>
                <el-radio v-model="payRadio" label="WX_PAY" @change="rechargeWayWX_PAY">微信支付</el-radio>
              </div>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width:130px;text-align:left;">汇款账户名称:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="text" placeholder="请输入汇款账户名称" v-model="remittanceAccountName"
                style="width:215px"></el-input>
              <i
                style="font-style:normal;display: inline;font-size: 10px;color:red">&nbsp;&nbsp;个人储蓄卡请填写持卡人姓名，对公账户请填写账户名称</i>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span
                style="width:130px;text-align:left;">汇款账户:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <el-input type="text" placeholder="请输入汇款账户" v-model="remittanceAccount" style="width:215px"></el-input>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'"
              style="display: flex;justify-content:flex-start;">
              <span style="width:130px;text-align:left;">汇款银行:</span>
              <div>
                <el-select placeholder="请输入汇款银行" v-model="currBank" style="width:215px">
                  <el-option v-for="item in remittanceBank" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'" style=" margin-bottom:40px ">
              <span style="width:130px;text-align:left; ">凭证:</span>
              <el-upload :multiple="true" action="#" accept="image/jpeg, image/gif, image/png, image/bmp"
                :file-list="fileList1" :http-request="fnUploadremittanceImgs" :show-file-list="false">
                <div v-if="'' != remittanceImgs" class="el-upload el-upload--picture-img">
                  <img v-for="remittanceImg of remittanceImgs" :key="remittanceImg.value" :src="remittanceImg"
                    style="width: 200px;" />
                </div>
                <div v-else class="el-upload el-upload--car-two">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="el-upload__tip">
                  请上传汇款回单凭证，只能上传jpg/png图片，且不超过500kb
                </div>
              </el-upload>
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">账户名称:</span>
              成都聚家科技有限公司
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">账户号码:</span>
              4402209109100103208
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">开户银行:</span>
              中国工商银行股份有限公司成都天顺路支行
            </div>
            <div class="recharge" v-if="this.payRadio == 'OFFLINE_REMIT'">
              <span style="width:130px;text-align:left;">汇款提示:</span>
              请避免北京时间18：00-00：00进行汇款，否则受银行出账时间影响，可能出现延迟一天到账情况。
            </div>
          </div>
          <div class="remittanceButton">
            <el-button round size="mini" @click="balancePayment">&nbsp;&nbsp;&nbsp;立即充值&nbsp;&nbsp;&nbsp;</el-button>
            <el-button round type="danger" size="mini"
              @click="rechargeDialog = false">&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          </div>
        </el-dialog>
      </template>
      <template>
        <el-dialog title="二维码支付" :visible.sync="QRCodeDialog" align="center">
          <vue-qr :text="config.value" :size="200"></vue-qr>
          <el-row>二维码只会展示2分钟，请及时支付</el-row>
          <el-button @click="destroyThisPay">关闭</el-button>
        </el-dialog>
      </template>
      <el-dialog center :visible.sync="dialogBalancePay" width="50%">
        <template slot="title">
          <div>
            <img src="../../../../../public/svg/money.svg" alt="" style="width:20px;margin-right:10px" />选择付款方式
          </div>
        </template>
        <p style="text-align:center;font-size:24px;">{{ dialogPaymoney }}</p>
        <p style="text-align:center; margin-bottom: 50px;">支付金额(元)</p>
        <div style="display: flex;justify-content: space-around;">
          <el-radio v-if="!noMoney" v-model="balancePayRadio" label="YE">账户余额({{ getBalance + "元" }})</el-radio>
          <el-radio v-if="noMoney" v-model="balancePayRadio" label="YE">
            账户余额(
            <span style="color:red">
              余额不足
              <a href="#" style="color:#409EFF;margin-left:3px;text-decoration: underline;" @click="toPayMoney">去充值</a>
            </span>)
          </el-radio>
          <el-radio v-model="balancePayRadio" label="WX">微信支付</el-radio>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogBalancePay = false">取 消</el-button>
          <el-button type="primary" @click="listPay">确认支付</el-button>
        </span>
      </el-dialog>
      <el-dialog title="评价" :visible.sync="evaluateDialog" width="50%" style="background-color: #4E5465">
        <el-row :gutter="20" style="margin: 10px;">
          <el-rate v-model="evaluateObj.star" @change="rateChange()" show-text></el-rate>
        </el-row>
        <el-row :gutter="20" style="margin: 10px;width: 50%;">
          <el-input type="textarea" v-model="evaluateObj.content"></el-input>
        </el-row>
        <span slot="footer" class="dialog-footer">
          <el-button @click="evaluateDialog = false">取 消</el-button>
          <el-button type="primary" @click="evaluate()">确 定</el-button>
        </span>
      </el-dialog>
      <template>
        <el-dialog title="工单信息" :visible.sync="dataDialog" align="center">
          <el-table :data="propertiesViceList" border>
            <el-table-column prop="secondClassifyName" align="center" label="字段名">
              <template slot-scope="scope">{{ scope.row.title }}</template>
            </el-table-column>
            <el-table-column prop="secondClassifyName" align="center" label="值">
              <template slot-scope="scope">
                <template v-if="scope.row.dataType != 'img'">{{
                  scope.row.value
                }}</template>
                <template v-if="scope.row.dataType == 'img'">
                  <viewer :images="formmaterImage(scope.row.value)">
                    <img v-for="src in formmaterImage(scope.row.value)" :src="src" :key="src" width="20" />
                  </viewer>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-table :data="serviceFee" v-if="showBottom">
            <el-table-column prop="secondClassifyName" align="center" border>
              <template slot-scope="scope">{{ scope.row.key }}</template>
            </el-table-column>
            <el-table-column prop="secondClassifyName" align="center" border>
              <template slot-scope="scope">{{ scope.row.value }}</template>
            </el-table-column>
          </el-table>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { workOrderOption } from "@/const/salesCloud/workOrderOption";
import {
  passAudit,
  refusedAudit,
  serviceListing,
  statusSearch,
  findWorkOrderList,
  updateWorkOrderMerchants,
  evaluation,
  immediatePay,
  findUsersByUserTypeAll,
  findUsersByUserType,
  balancePay,
  insertWorkOrderMerchants,
  userRefused,
  cancelWorkOrder,
  delItem,
  findWorkOrderListDownloadExcel,
} from "@/api/work/serviceOrder";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import { findByLabel } from "@/util/util";
import oss from "ali-oss";
import md5 from "js-md5";
import { findBalance, addBalance } from "@/api/salesCloud/accountBalance";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findProject, checkCardNumber } from "@/api/work/serviceItem";
import { findUserList } from "@/api/work/projectService";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
export default {
  name: "workOrder",
  components: {
    VueQr,
  },
  data() {
    return {
      tableOption: workOrderOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogVisible: false,
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      dialogPaymoney: "",
      from: {
        text: "",
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      //余额支付
      balancePayRadio: "YE",
      serviceCategorys: [],
      superiorId: {},
      reservationNum: "",
      serviceCategoryName: {},
      categoryTypes: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      noMoney: true,
      getBalance: 0,
      evaluateDialog: false,
      dialogBalancePay: false,
      rechargeDialog: false,
      rechargeMoney: "",
      showBottom: false,
      payRadio: "OFFLINE_REMIT",
      remittanceAccountName: "",
      remittanceAccount: "",
      currBank: "",
      remittanceBank: DIC.BANK_LIST,
      fileList1: [],
      remittanceImgs: [],

      score: 5,
      clues: [],
      evaluateObj: {},
      paymentTask: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      dataDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      statusData: [
        {
          value: "WAIT_DISTRIBUTE",
          label: "待派发",
        },
        {
          value: "WAIT_ACCEPT",
          label: "待受理",
        },
        {
          value: "IN_SERVICE",
          label: "服务中",
        },
        {
          value: "TO_BE_CONFIRMED",
          label: "待确认(用户确认)",
        },
        {
          value: "TO_BE_THE_FINAL",
          label: "待终审",
        },
        {
          value: "WAIT_PAY",
          label: "待付款",
        },
        {
          value: "HAS_BEEN_RETURNED_USER",
          label: "已退回(用户退回)",
        },
        {
          value: "HAS_BEEN_RETURNED_USER_PLATFORM",
          label: "已退回(用户平台)",
        },
        {
          value: "TO_EVALUATE",
          label: "待评价",
        },
        {
          value: "SOLVE",
          label: "已完成",
        },
        {
          value: "INVALID",
          label: "失效",
        },
      ],
      value: "",
      downloadData: {},
    };
  },
  created() {
    findProject().then((res) => {
      let data = JSON.parse(res.data);
      this.serviceCategorys = data;
    });
    this.handleList();
  },
  watch: {
    /* $route(to) {
      // 检查是否存在 refresh 标识且为 true
      if (to.query.refresh === 'true') {
        // 执行你的逻辑
        findProject().then((res) => {
          let data = JSON.parse(res.data);
          this.serviceCategorys = data;
        });
        this.handleList();

        // 删除 refresh 标识
        const query = { ...to.query };
        delete query.refresh;

        // 使用 replace 来清除 URL 中的 refresh 标识，避免页面刷新后重复执行
        this.$router.replace({ path: to.path, query });
      }
    } */
  },
  mounted() { },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    getStatusTagType(status) {
      // console.log(status, "status");
      if (status === "SOLVE") {
        return "success";
      } else if (status === "WAIT_PAY" || status === "TO_EVALUATE") {
        return "info";
      } else if (
        status === "INVALID" ||
        status === "WAIT_DISTRIBUTE" ||
        status === "WAIT_ACCEPT"
      ) {
        return "danger";
      } else if (status === "IN_SERVICE" || status === "ENGINEER_ON_THE_WAY") {
        return "primary";
      } else {
        return "warning";
      }
    },
    // 查询预约卡号是否存在
    async checkreservationNum(row) {
      console.log(row.reservationNum, "预约卡号");
      this.reservationNum = row.reservationNum;
      const params = {
        cardNumber: row.reservationNum,
        clientType: "JOINS_USER",
      };
      // 加载中
      this.loading = true;
      if (this.reservationNum.length == 12) {
        checkCardNumber(params).then((res) => {
          // 加载结束
          this.loading = false;
          if (res.code == "200") {
            let json = JSON.parse(res.data);
            if (json.errCode !== "0") {
              this.$message({
                showClose: true,
                message: json.errCode,
                type: "error",
              });
              // 清空预约卡号
              this.reservationNum = "";
              row.reservationNum = "";
            }
          } else if (res.code == 500) {
            this.$message({
              showClose: true,
              message: "系统错误，请重新输入",
              type: "error",
            });
            // 清空预约卡号
            this.reservationNum = "";
          } else if (res.code == 14007062) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            // 清空预约卡号
            this.reservationNum = "";
            row.reservationNum = "";
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            // 清空预约卡号
            this.reservationNum = "";
            row.reservationNum = "";
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请输入12位预约卡号",
          type: "error",
        });
        // 清空预约卡号
        this.reservationNum = "";
        row.reservationNum = "";
      }
    },
    remoteMethod(query) {
      if (/[^\x00-\xff]/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              console.log(data);
              this.users = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (/^\d{11}$/.test(query)) {
        this.users = [];
        setTimeout(() => {
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              console.log(data);
              this.users = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },

    selectSuperiorId(e) {
      console.log(e);
      let params = {};
      params.superiorId = e.id;
      findProject(params).then((res) => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.categoryTypes = data;
        this.serviceCategoryName = {};
      });
    },
    passAudit(row, index) {
      console.log(row, index);
      this.$confirm(`是否确认通过?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {};
        params.id = row.id;
        passAudit(params).then((res) => {
          console.log(res);
          this.handleList();
        });
      });
    },
    rejectAudit(row, index) {
      this.$prompt("请输入拒绝原因", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      })
        .then(({ value }) => {
          let obj = {};
          obj.id = row.id;
          obj.reason = value;
          refusedAudit(obj).then((response) => {
            if (response.code == "200") {
              this.$message({
                showClose: true,
                message: "操作成功",
                type: "success",
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: "提交出错",
            type: "error",
          });
        });
    },
    openPay(row) {
      console.log(row);
      this.dialogPaymoney = "";
      this.payRow = row;
      findBalance().then((res) => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        let wxPay = row.payMoney;
        this.dialogPaymoney = row.payMoney;
        // let wxPay = 1111111;
        console.log(wxPay, this.getBalance);
        this.noMoney = wxPay > this.getBalance;
        this.dialogBalancePay = true;
      });
    },
    getBalanceMoney() {
      findBalance().then((res) => {
        let data = JSON.parse(res.data);
        this.getBalance = data.rows[0].balance;
        console.log(this.getBalance);
      });
    },
    listPay() {
      if (this.balancePayRadio == "WX") {
        this.immediatePayment(this.payRow);
      } else {
        let obj = {};
        obj.id = this.payRow.id;
        balancePay(obj).then((res) => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success",
            });
            setTimeout(() => {
              this.handleList();
            }, 2000);
            this.dialogBalancePay = false;
          } else {
            this.$message({
              showClose: true,
              message: "余额不足",
              type: "error",
            });
            this.handleList();
            this.dialogBalancePay = false;
          }
        });
      }
    },
    destroyThisPay() {
      this.QRCodeDialog = false;
      this.rechargeDialog = false;
      this.payMoneyDialog = false;
      this.dialogBalancePay = false;
    },
    clean() {
      this.describeImgs = [];
      this.remittanceImgs = [];
      this.reservationNum = "";
      // 工程师清空
      this.workerUser = "";
      this.rechargeMoney = "";
      this.paymentTask = {};
      this.remittanceAccountName = "";
      this.remittanceAccount = "";
      this.currBank = "";
      this.workerUser = "";
      this.serviceItem = "";
    },
    balancePayment() {
      let params = {};
      params.money = this.rechargeMoney;
      params.rechargeType = "BALANCE";
      params.payType = this.payRadio;
      params.openingUser = this.remittanceAccountName;
      params.bankNumber = this.remittanceAccount;
      params.bankName = this.currBank;
      params.url = this.remittanceImgs + "";
      if (params.payType == "OFFLINE_REMIT") {
        if (
          params.money &&
          params.openingUser &&
          params.bankNumber &&
          params.bankName &&
          params.url
        ) {
          addBalance(params).then((res) => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message:
                  "非常感谢您对慧家平台的信任，请耐心等待平台财务人员核实。",
                type: "success",
              });
              this.rechargeDialog = false;
              this.payMoneyDialog = false;
              this.dialogBalancePay = false;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请完善输入信息",
            type: "error",
          });
        }
      } else {
        addBalance(params).then((response) => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then((res) => {
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function () {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "充值成功",
                      type: "success",
                    });
                    _this.handleList();
                    _this.payMoneyDialog = false;
                    _this.rechargeDialog = false;
                    _this.dialogBalancePay = false;
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then((res) => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function () {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "充值成功",
                              type: "success",
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.dialogBalancePay = false;
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.rechargeDialog = false;
                          this.dialogBalancePay = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error",
                          });
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.rechargeDialog = false;
                        this.dialogBalancePay = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error",
                        });
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付失败",
                  type: "error",
                });
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: "支付失败",
              type: "error",
            });
            //???下面的感觉没用
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    },
    rechargeWayBALANCE() {
      this.paymentTask.rechargeWay = "BALANCE";
    },
    rechargeWayWX_PAY() {
      this.paymentTask.rechargeWay = "WX_PAY";
    },
    rechargeWayOFFLINE_REMIT() {
      this.paymentTask.rechargeWay = "OFFLINE_REMIT";
    },
    toPayMoney() {
      console.log("充值");
      this.clean();
      this.rechargeDialog = true;
    },

    statusChange() {
      //下拉框状态发生改变时
      //console.log(this.value);
      let params = this.value;
      statusSearch(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].reservationTime = data.rows[i].serviceTime;
        }
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].reservationTime = data.rows[i].serviceTime;
        }
        this.tableData = data.rows;
        console.log(this.tableData);
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      //有搜索回调不用直接方法调用
      //自定义搜索需要调用清空方法
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      this.superiorId = {};
      this.serviceCategoryName = {};
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      params.startPayTime = "";
      params.endPayTime = "";
      params.serviceCategoryId = "";
      params.serviceItemId = "";
      params.startTime = "";
      params.endTime = "";
      // 对象属性删除
      //   delete params.serviceCategoryId
      //   delete params.serviceItemId
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.serviceCategoryId = this.serviceCategory.id
        ? this.serviceCategory.id
        : "";
      console.log(params.startDate_endDate);
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      }
      if (
        null != params.payTimeInterval &&
        undefined != params.payTimeInterval &&
        "" != params.payTimeInterval
      ) {
        params.startPayTime = params.payTimeInterval[0];
        params.endPayTime = params.payTimeInterval[1];
      }
      // console.log(this.$refs.crud.resetForm)
      params.serviceCategoryId = "";
      if (this.superiorId.id != undefined) {
        params.serviceCategoryId = this.superiorId.id;
      }
      params.serviceItemId = "";
      if (this.serviceCategoryName.id != undefined) {
        params.serviceItemId = this.serviceCategoryName.id;
      }
      this.downloadData = params;
      console.log(params);
      console.log(this);
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].reservationTime = data.rows[i].serviceTime;
        }
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      findWorkOrderList(params).then((res) => {
        let data = JSON.parse(res.data);
        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].reservationTime = data.rows[i].serviceTime;
        }
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize,
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) { },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.clean();
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      console.log(row);
      this.users = [];
      this.users.push({
        id: row.workerUserId,
        realName: row.realName + "(" + row.mobile + ")",
        mobile: row.mobile,
      });
      if (
        this.users[0].realName == "null(null)" ||
        this.users[0].id == null ||
        this.users[0].mobile == null
      ) {
        this.users[0].realName = "";
      }
      row.reservationTime = row.serviceTime;
      this.workerUser = {};
      this.serviceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      this.workerUser.id = row.workerUserId;
      let location = {};
      console.log("集合：" + JSON.stringify(row));
      location.lng = row.longitude;
      location.lat = row.latitude;
      this.reservationNum = row.reservationNum;
      this.point.location = location;
      this.point.pname = row.province;
      this.point.cityname = row.city;
      this.point.adname = row.area;
      this.point.address = row.address;
      this.point.adcode = row.cityCode;
      console.log("row", row);
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      findWorkOrderList(parmas).then((res) => {
        let data = JSON.parse(res.data);
        for (let i = 0; i < data.rows.length; i++) {
          data.rows[i].reservationTime = data.rows[i].serviceTime;
        }
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      console.log(this.point);
      if (this.point.location) {
        row.cityCode = this.point.adcode;
        row.longitude = this.point.location.lng;
        row.latitude = this.point.location.lat;
      } else {
        this.$message({
          showClose: true,
          message: "请选择坐标",
          type: "error",
        });
        done();
        return;
      }
      if (row.appointmentType == "OWNER") {
        row.ownerMobile = row.reservationMobile;
        row.ownerName = row.reservationName;
      }
      row.cityCode = this.point.adcode;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.address = this.point.address;
      row.workerUserId = this.workerUser.id;
      row.serviceItemId = this.serviceItem;
      row.reservationNum = this.reservationNum;
      console.log(row);
      console.log("serviceItem：" + JSON.stringify(this.serviceItem));
      insertWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
            this.clean();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
          this.clean();
          this.handleList();
        })
        .catch((error) => {
          this.loading = false;
          this.clean();
          this.handleList();
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(dicName, label) {
      if (this.$refs.crud.tableSelect.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择要操作的数据",
          type: "error",
        });
        return;
      }

      this.$confirm(`是否确认删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = new Array();
          for (let row of this.$refs.crud.tableSelect) {
            ids.push(row.id);
          }

          delItem(findByLabel(DIC.DELETE_OPTION, label), ids)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.cityCode = this.point.adcode;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.address = this.point.address;
      row.workerUserId = this.workerUser.id;
      row.reservationNum = this.reservationNum;
      if (row.appointmentType == "OWNER") {
        row.ownerMobile = row.reservationMobile;
        row.ownerName = row.reservationName;
      }
      console.log("集合：" + JSON.stringify(row));
      updateWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
            this.handleList();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
          this.handleList();
        });
      done();
    },
    choseWorkServiceItem() {
      let params = {};
      params.superiorId = this.serviceCategory.id;
      findProject(params).then((res) => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
      });
      this.serviceItem = "";
    },
    choseServiceItem(data) {
      console.log(data);
      this.serviceItemId = data;
    },
    userRefused(row) {
      this.$prompt("请输入拒绝理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      }).then(({ value }) => {
        let obj = {};
        obj.id = row.id;
        obj.reason = value;
        userRefused(obj).then((res) => {
          this.handleList();
        });
      });
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      console.log(row);
      console.log(this);
      immediatePay(obj).then((response) => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(() => {
                  _this.QRCodeDialog = false;
                  _this.dialogBalancePay = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success",
                  });
                  _this.handleList();
                  this.handleList();
                }, 2000);
              } else {
                this.QRCodeDialog = false;
                this.dialogBalancePay = false;

                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
              }
              this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.dialogBalancePay = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error",
              });
              this.handleList();
            }
          });

          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;

          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
          // this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },
    evaluate() {
      // this.evaluateObj.workOrderId=row.id;
      console.log("集合：" + JSON.stringify(this.evaluateObj));
      // evaluation(this.serviceCategory.id).then((res) => {
      //     let data = JSON.parse(res.data)
      //     this.joinsWorkServiceItems = data
      // })

      evaluation(this.evaluateObj)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success",
            });
            this.handleList();
            this.evaluateDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
    },
    /* serviceListing(row) {
      this.dataDialog = true;
      this.showBottom = false;
      serviceListing(row.id).then((res) => {
        this.workOrderData = [];
        this.serviceFee = [];
        this.propertiesViceList = [];
        let data = JSON.parse(res.data);
        this.workOrderData = data;
        console.log(data);
        this.propertiesViceList = data.propertiesViceList;
        if (data.serviceFee.servicePrice) {
          let obj = { key: "收费标准", value: data.serviceFee.servicePrice };
          this.serviceFee.push(obj);
        }
        if (data.serviceFee.otherExpensesAmount) {
          let obj1 = {
            key: "其他费用",
            value: data.serviceFee.otherExpensesAmount,
          };
          this.serviceFee.push(obj1);
        }
        if (data.serviceFee.otherChargesDesc) {
          let obj2 = {
            key: "其他费用备注",
            value: data.serviceFee.otherChargesDesc,
          };
          this.serviceFee.push(obj2);
        }

        let obj3 = { key: "总费用", value: data.serviceFee.servicePriceTotal };
        this.serviceFee.push(obj3);
        if (data.serviceFee.servicePriceTotal != null) {
          this.showBottom = true;
        }
        console.log("工单详情:" + JSON.stringify(this.propertiesViceList));
        console.log("serviceFee:" + JSON.stringify(this.serviceFee));
      });
    }, */
    serviceListing(row) {
      // 跳转到新的页面，并传递工单信息
      this.$router.push({
        path: "/work/serviceOrder/view",
        query: {
          id: row.id,
        },
      });
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          if (picArray[i] != "null") {
            str.push(picArray[i]);
          }
        }
      }
      return str;
    },
    cancelWorkOrder(id) {
      this.$confirm(`是否确认取消该工单?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelWorkOrder(id)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => { });
    },
    async fnUploadremittanceImgs(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            this.fileList1 = files;
            let array = results.res.requestUrls[0].split("?");
            this.remittanceImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    downloadExcelWorkOrder() {
      let params = this.downloadData;
      /*  findWorkOrderListDownloadExcel(params).then((res) => {
         window.open(res);
       }); */
      findWorkOrderListDownloadExcel(params).then((response) => {
        // 提取文件名
        const filename = response.headers["content-disposition"].match(
          /filename=(.*)/
        )[1];
        // 将二进制流转为blob
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
          window.navigator.msSaveBlob(blob, decodeURI(filename));
        } else {
          // 创建新的URL并指向File对象或者Blob对象的地址
          const blobURL = window.URL.createObjectURL(blob);
          // 创建a标签，用于跳转至下载链接
          const tempLink = document.createElement("a");
          tempLink.style.display = "none";
          tempLink.href = blobURL;
          tempLink.setAttribute("download", decodeURI(filename));
          // 兼容：某些浏览器不支持HTML5的download属性
          if (typeof tempLink.download === "undefined") {
            tempLink.setAttribute("target", "_blank");
          }
          // 挂载a标签
          document.body.appendChild(tempLink);
          tempLink.click();
          document.body.removeChild(tempLink);
          // 释放blob URL地址
          window.URL.revokeObjectURL(blobURL);
          this.handleList();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.remittanceButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}

/* .remittance {
  .recharge {
    margin-top: 10px;
  }
} */

.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
::v-deep .el-table--medium td {
  padding: 0 !important;
}
::v-deep .el-table {
  font-size:12px !important;
}
::v-deep .el-form-item {
    margin-bottom: 0px !important;
}
::v-deep .el-table--medium th {
    padding: 0px !important;
}
::v-deep .el-table td .el-table th {
    padding: 0px !important;
}
</style>
